import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const AddSquareIcon = forwardRef<SVGSVGElement, IconProps>(function AddSquareIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <g id="Icon/12px/Outline/add-square">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.34884 6C3.34884 5.76881 3.53625 5.5814 3.76744 5.5814H8.23256C8.46375 5.5814 8.65116 5.76881 8.65116 6C8.65116 6.23119 8.46375 6.4186 8.23256 6.4186H3.76744C3.53625 6.4186 3.34884 6.23119 3.34884 6Z"
            fill={color || 'currentColor'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 3.34884C6.23119 3.34884 6.4186 3.53625 6.4186 3.76744V8.23256C6.4186 8.46375 6.23119 8.65116 6 8.65116C5.76881 8.65116 5.5814 8.46375 5.5814 8.23256V3.76744C5.5814 3.53625 5.76881 3.34884 6 3.34884Z"
            fill={color || 'currentColor'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.02958 1.02958C1.7744 0.284763 2.88895 0 4.32558 0H7.67442C9.11105 0 10.2256 0.284763 10.9704 1.02958C11.7152 1.7744 12 2.88895 12 4.32558V7.67442C12 9.11105 11.7152 10.2256 10.9704 10.9704C10.2256 11.7152 9.11105 12 7.67442 12H4.32558C2.88895 12 1.7744 11.7152 1.02958 10.9704C0.284763 10.2256 0 9.11105 0 7.67442V4.32558C0 2.88895 0.284763 1.7744 1.02958 1.02958ZM1.62158 1.62158C1.11059 2.13257 0.837209 2.97152 0.837209 4.32558V7.67442C0.837209 9.02848 1.11059 9.86743 1.62158 10.3784C2.13257 10.8894 2.97152 11.1628 4.32558 11.1628H7.67442C9.02848 11.1628 9.86743 10.8894 10.3784 10.3784C10.8894 9.86743 11.1628 9.02848 11.1628 7.67442V4.32558C11.1628 2.97152 10.8894 2.13257 10.3784 1.62158C9.86743 1.11059 9.02848 0.837209 7.67442 0.837209H4.32558C2.97152 0.837209 2.13257 1.11059 1.62158 1.62158Z"
            fill={color || 'currentColor'}
          />
        </g>
      </g>
    </svg>
  );
});
